export const ImprimirEnIframe = (htmlContent, title = 'Documento de Impresión', spacerHeight = '20px') => {
    // 1. Crear el iframe
    const iframe = document.createElement('iframe');

    // 2. Estilos para ocultar el iframe (no queremos que sea visible)
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    iframe.title = title;

    // 3. Agregar el iframe al DOM
    document.body.appendChild(iframe);

    // 4. Establecer el manejador onload para la impresión y la limpieza
    // ESTA ES LA CLAVE: Esperamos a que el iframe haya cargado COMPLETAMENTE el contenido.
    iframe.onload = function () {
        try {
            // Aseguramos el foco para que el diálogo de impresión se abra
            iframe.contentWindow.focus();
            // Ejecutamos la impresión
            iframe.contentWindow.print();
        } catch (error) {
            console.error("Error al imprimir en iframe:", error);
        }

        // Limpieza: Eliminamos el iframe después de un tiempo prudente
        // El retraso de 5 segundos es para dar tiempo al usuario de interactuar con el diálogo de impresión
        setTimeout(() => {
            if (document.body.contains(iframe)) {
                document.body.removeChild(iframe);
            }
        }, 5000);
    };


    // 5. Obtener el documento interno del iframe
    const doc = iframe.contentWindow.document;

    // 6. Escribir el HTML completo (se ha eliminado la etiqueta <script> interna)
    doc.open();
    doc.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <title>${title}</title>
            <meta name="viewport" content="width=280px, initial-scale=1.0, maximum-scale=1.0, user-scalable=0">
            <style>
                /* Estilos base */
                body {
                    font-family: 'Arial', sans-serif;
                    margin: 0 !important;
                    padding: 0 !important; 
                    
                    background: none !important; 
                    color: black !important;
                }
                img {
                    max-width: 100%;
                }
                
                /* Estilos de impresión (UNIFICADO Y OPTIMIZADO) */
                @media print {
                    @page { 
                        /* CORRECCIÓN #1: Margen CERO para evitar cortes y espacio extra */
                        margin: 0 !important; 
                        size: auto;
                    }
                    html, body {
                            /* Aseguramos que el HTML y el BODY no tengan márgenes ni rellenos */
                            margin: 0 !important;
                            padding: 0 !important;
                            
                            /* Esto es CRUCIAL para evitar el fondo */
                            background-color: transparent !important;
                            -webkit-print-color-adjust: exact !important; 
                            print-color-adjust: exact !important;
                        }
                    img {
                        /* Esto ayuda a que el logo se imprima en blanco y negro */
                        filter: grayscale(100%);
                        -webkit-filter: grayscale(100%);
                    }
                    /* Asegura que todos los elementos sean negros y sin fondo */
                    * {
                        color: black !important;
                        background-color: transparent !important;
                        box-shadow: none !important;
                        text-shadow: none !important;
                    }
                        body > div:last-child {
                        margin-bottom: -10mm !important; /* Intenta jalar el corte hacia arriba */
                    }
                }
            </style>
        </head>
        <body>
            ${htmlContent}
            <div style="height: ${spacerHeight}; visibility: hidden;">&nbsp;</div>
            </body>
        </html>
    `);
    doc.close();
};